import { connect } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import { actions as TrackingActions } from 'app/modules/tracking'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({
    track: TrackingActions.track
  }, dispatch)
})

const withTracking = WrappedComponent =>
  compose(connect(null, mapDispatchToProps))(WrappedComponent)

export default withTracking



// WEBPACK FOOTER //
// ./src/scripts/components/hocs/withTracking.js